module.exports = __webpack_public_path__ + "img/20240320153259635e8j.7613b9bc.jpg";